/**
 * Whether a failed /user/me means "not signed in" (401, or 403 for a blocked
 * account) rather than server trouble. Only the former may send someone to
 * the login page: a 5xx during a deploy or a dropped connection used to throw
 * a signed-in user out of the page they were on, into a /login ↔ /cabinet
 * redirect loop that lasted as long as the outage.
 */
export const isSignedOutError = (error: unknown): boolean => {
  const status = (error as { status?: unknown } | null | undefined)?.status
  return status === 401 || status === 403
}
